import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { Images } from './images';

import * as api from '../api';

export const SystemsPanel = observer(({ store }) => {
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <Images store={store} api={api.ASSETS_API + '?artboardSection=systems'} />
    </div>
  );
});

export const SystemsSection = {
  name: 'Systems',
  Tab: (props) => (
    <SectionTab name="Systems" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/architectural-systems.svg'}
        alt="Systems"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  Panel: SystemsPanel,
};
